import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import errorLog from './modules/errorLog'
import permission from './modules/permission'
import user from './modules/user'
import getters from './getters'
import common from './modules/common'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    errorLog,
    common,
    permission,
    user
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js